import client from '../plugins/client';

export default {
  async registerShipper(data) {
    return client.post('/users', data);
  },

  async registerCompany(data) {
    return client.post('/users/transporter', data);
  },

  async verifyUser(token) {
    return client.post('/users/verify', { token });
  },
};
